
export default (eventName, data) => {

    const onAfterCookieDeclined = 'onAfterCookieDeclined';
    const onBeforeCookieAccept = 'onBeforeCookieAccept';
    
    const event = new Event(eventName);
    event.data = data;
    window.dispatchEvent(event);
}
